import React from 'react'
import { Box, Typography, CardHeader, Avatar } from '@mui/material'
import { ChatContext } from '../../../contexts/ChatContext'
import { LabelPedido } from '../../Simple'

import { stDesk } from './stylesHC'

export default function HeaderChat() {
  const { sttChatCtx } = React.useContext(ChatContext)

  function ReturnStatusPedido(status) {
    switch (status) {
      case 'SOLICITADO':
        return (
          <Typography sx={{ ...stDesk.labelCardHeader, color: '#ff7043', fontWeight: 'bold' }} variant='h6'>
            {status}
          </Typography>
        )
      case 'AGENDADO':
        return (
          <Typography sx={{ ...stDesk.labelCardHeader, color: '#24ad49', fontWeight: 'bold' }} variant='h6'>
            {status}
          </Typography>
        )
      case 'CANCELADO':
        return (
          <Typography sx={{ ...stDesk.labelCardHeader, color: '#bf3324', fontWeight: 'bold' }} variant='h6'>
            {status}
          </Typography>
        )
      case 'REALIZADO':
        return (
          <Typography sx={{ ...stDesk.labelCardHeader, color: '#00cda4', fontWeight: 'bold' }} variant='h6'>
            {status}
          </Typography>
        )
    }
  }

  return (
    <Box sx={stDesk.containHeader}>
      <CardHeader
        sx={stDesk.containCardHeader}
        avatar={<Avatar sx={stDesk.iconAvatar} src={sttChatCtx.chat.pedido.empresa.nome} alt={sttChatCtx.chat.pedido.empresa.nome} />}
        title={
          <Typography sx={stDesk.titleCardHeader} variant='h6'>
            {sttChatCtx.chat.pedido.empresa.nome}
          </Typography>
        }
        subheader={
          sttChatCtx.chat.pedido.dataInicio ? (
            <Box sx={stDesk.containSubHeader}>
              <Typography sx={stDesk.labelCardHeader} variant='h6'>
                {sttChatCtx.chat.pedido.quadra.endereco}
              </Typography>
              <Typography sx={stDesk.labelCardHeader} variant='h6'>
                {sttChatCtx.chat.pedido.quadra.descricao}
              </Typography>
            </Box>
          ) : (
            <></>
          )
        }
      />
      {sttChatCtx.chat.pedido.dataInicio && <LabelPedido pedido={sttChatCtx.chat.pedido} />}
      {sttChatCtx.chat.pedido.status && (
        <Box sx={stDesk.containStatusPdd}>
          {ReturnStatusPedido(sttChatCtx.chat.pedido.status)}
          <Typography sx={stDesk.labelCardHeader} variant='h6'>
            Agendamento: #{sttChatCtx.chat.pedido.idpedido}
          </Typography>
          <Typography sx={{ ...stDesk.labelCardHeader, color: 'black', fontWeight: 'bold' }} variant='h6'>
            {`R$ ${sttChatCtx.chat.pedido.valorTotal.toFixed(2).replace('.', ',')}`}
          </Typography>
        </Box>
      )}
    </Box>
  )
}
